import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminAccountDetail } from '@apps/web/components/admin/accounts/account_detail';
import { ACCOUNT_DETAIL_TABS } from '@apps/web/components/admin/accounts/account_detail_tabs';

const accountDetailSearchSchema = z.object({
    tab: z.enum(ACCOUNT_DETAIL_TABS).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/admin/accounts/$accountId')({
    component: AdminAccountDetailPage,
    validateSearch: accountDetailSearchSchema,
    head: () => ({
        meta: [{ title: 'Account | Phoebe Admin' }],
    }),
});

function AdminAccountDetailPage() {
    const { accountId } = Route.useParams();

    return <AdminAccountDetail accountId={accountId} />;
}
